<template>
  <g>
    <path
      d="M17 11.0002C17.34 11.0002 17.67 11.0402 18 11.0902V7.58018C18 6.78018 17.53 6.06018 16.8 5.75018L11.3 3.35018C10.79 3.13018 10.21 3.13018 9.7 3.35018L4.2 5.75018C3.47 6.07018 3 6.79018 3 7.58018V11.1802C3 15.7202 6.2 19.9702 10.5 21.0002C11.05 20.8702 11.58 20.6802 12.1 20.4502C11.41 19.4702 11 18.2802 11 17.0002C11 13.6902 13.69 11.0002 17 11.0002Z"
    />
    <path
      d="M17 13.0002C14.79 13.0002 13 14.7902 13 17.0002C13 19.2102 14.79 21.0002 17 21.0002C19.21 21.0002 21 19.2102 21 17.0002C21 14.7902 19.21 13.0002 17 13.0002ZM17 14.3802C17.62 14.3802 18.12 14.8902 18.12 15.5002C18.12 16.1102 17.61 16.6202 17 16.6202C16.39 16.6202 15.88 16.1102 15.88 15.5002C15.88 14.8902 16.38 14.3802 17 14.3802ZM17 19.7502C16.07 19.7502 15.26 19.2902 14.76 18.5802C14.81 17.8602 16.27 17.5002 17 17.5002C17.73 17.5002 19.19 17.8602 19.24 18.5802C18.74 19.2902 17.93 19.7502 17 19.7502Z"
    />
  </g>
</template>
